import { LoadedProps, RouteLoadProps, useRouter } from '@components/router';
import { defCalRoute } from './common';
import { rpx } from 'client/lib/rpx-client';
import { CalendarForm } from '@components/calendar-form';
import { ruzcal } from 'shared/urls';
import { useDocumentTitle } from 'client/utils/use-document-title';
import { CalPublicLayout } from './cal-public-layout';
import { showToast } from '@components/toaster';

export const route = defCalRoute({ isPublic: true, load, Page });

async function loadForm(formId?: string) {
  if (!formId) {
    return undefined;
  }
  const form = await rpx.ruzcalForms.getFullForm({ formId });
  return form;
}

async function load(props: RouteLoadProps) {
  const result = await rpx.ruzcalEvents.getEvent({
    eventId: props.params.eventId,
  });

  const form = await loadForm(result.eventType.formId);

  return {
    status: 'ok',
    ...result,
    form: form,
  };
}

type Props = LoadedProps<typeof load>;

function Page({ state }: Props) {
  const { attendee } = state;
  const router = useRouter();

  useDocumentTitle(['Just one more step ...']);

  function onFormSave() {
    showToast({
      title: 'Responses saved',
      type: 'ok',
      message: 'Your responses have been saved.',
    });
    router.goto(ruzcal.existingBookingUrl({ id: state.event.id, success: true }));
  }

  function onFormSkip() {
    showToast({
      title: 'Form skipped',
      type: 'ok',
      message: 'You can always come back to this page later and fill out the form.',
    });
    router.goto(ruzcal.existingBookingUrl({ id: state.event.id, success: false }));
  }

  return (
    <CalPublicLayout>
      <section class="p-8 bg-white rounded-2xl max-w-full w-2xl flex flex-col gap-6 an-scale-in">
        <header>
          <h1 class="text-2xl font-semibold">Just one more step ...</h1>
        </header>
        <section class="flex flex-col border-t py-6 gap-8">
          {state.form && (
            <CalendarForm
              form={state.form}
              userId={attendee.userId}
              eventId={state.event.id}
              readonly={false}
              onSave={onFormSave}
              onSkip={onFormSkip}
            />
          )}
        </section>
      </section>
    </CalPublicLayout>
  );
}
